<template>
  <el-dialog
    top="10vh"
    :title="$t('Fota.dataDeclaration')"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="showModel"
  >
    <div class="title">{{ $t('Fota.statisticTime') }}</div>
    <div class="content">
      {{ $t('Fota.tips1') }}
    </div>
    <div class="title">{{ $t('Fota.statisticRange') }}</div>
    <div class="content">
      {{ $t('Fota.tips2') }}
    </div>
    <div class="title">{{ $t('Fota.failReason') }}</div>
    <div class="content">
      {{ $t('Fota.tips3') }}
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showModel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('update:showModel', false)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}
.title {
  margin-top: 24px;
  padding-left: 16px;
  width: 318px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  background-image: linear-gradient(270deg, rgba(51, 157, 255, 0) 0%, rgba(51, 157, 255, 0.2) 100%);
  border-radius: 7px 8px 8px 7px;
}
.content {
  margin-top: 8px;
  padding-left: 16px;
  line-height: 22px;
  font-size: 14px;
  color: #666666;
}
</style>
